<template>
  <div class="dialect-square">
    <div class="content-pc">
      <div class="bg">
        <a-carousel :autoplay='true'>
          <div>
            <img src="../../assets/img/banner-1.jpg" alt="">
          </div>
          <div>
            <img src="../../assets/img/banner-2.jpg" alt="">
          </div>
          <div>
            <img src="../../assets/img/banner-3.jpg" alt="">
          </div>
        </a-carousel>
      </div>
      <div class="contain">
          <div style="height:200px;background:#fff;padding:24px;box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);border-radius:4px">
            <div style="color:rgba(51, 51, 51, 1);font-size:18px;font-weight:bold">项目类型</div>
             <a-divider style="margin-top:16px;background:rgba(240, 240, 240, 1)" />
            <div style="margin-top:24px;display:flex;">
                <span style="width:130px;color:rgba(153, 153, 153, 1);font-size:14px;display:inline-block">选择所属行业：</span>
                <div class="tag-list">
                  <span :class="{'active':selectedTagId==''}" @click="handleChange(-2)">全部</span>
                  <span v-for="(tag, index) in belongsToTpeList" :key="index"
                      :class="{'active':selectedTagId==tag.id}"
                      @click="handleChange(tag.id)"
                      style="display:inline-block"
                    >
                      {{tag.name}}
                  </span>
                  <span :class="{'active':selectedTagId==-1}" @click="handleChange(-1)">其他</span>
                </div>
            </div>
            <div style="margin-top:24px;">
              <span style="width:130px;color:rgba(153, 153, 153, 1);font-size:14px;display:inline-block">类型：</span>
              <a-radio-group v-model="value" @change="handleSelectChange">
                <a-radio value="">
                  全部
                </a-radio>
                <a-radio :value="'IN'">
                  呼入
                </a-radio>
                <a-radio :value="'OUT'">
                  呼出
                </a-radio>
              </a-radio-group>
            </div>
          </div>
          <div style="clear:both"></div>
          <div class="card-list">
            <div class="card" :title="item.name" v-for="(item, index) in proList" :key="index" :class="{'distance-right':(index+1)%5!=0}" @click="selectItem(item)">
              <div class="img-mask" style="overflow-y:hidden">
                <img v-if="item.picture!=''" :src="item.picture"  style="width:100%"/>
                <img v-if="item.picture==''"  src="../../assets/img/pro1.png"  style="width:100%"/>
                <div class="mask">
                  <div style="font-size:14px">项目简介：</div>
                  <div :title="item.description" style="font-size:14px;margin-top:10px;max-height:90px;overflow:hidden">
                    {{item.description}}
                  </div>
                  <div style="font-size:12px;margin-top:20px">
                    <span style='float:left'>
                      {{item.createTime}}
                    </span>
                  </div>
                </div>
              </div>
              <div style="padding:18px 16px 0">
                <div>
                  <span style="color:rgba(51, 51, 51, 1);font-size:16px;float:left">{{item.name.length>13?item.name.substring(0,13)+'...':item.name}}</span>
                </div>
                <div style="clear:both"></div>
                <div class="node-count" style="margin-top:8px;">
                  <span v-if="item.typeStr=='呼入'" style="color:rgba(255, 141, 26, 1);font-size:12px;margin-right:4px;">[{{item.typeStr}}]</span>
                  <span v-if="item.typeStr=='呼出'" style="color:rgba(78, 138, 250, 1);font-size:12px;margin-right:4px;">[{{item.typeStr}}]</span>
                  <span style="">节点：</span>
                  <span :class="{'type-in':item.typeStr=='呼入'}" style="margin-right:16px;">{{item.nodeCount}}</span>
                  <span>意图：</span>
                  <span :class="{'type-in':item.typeStr=='呼入'}" style="margin-right:16px;">{{item.intentionCount}}</span>
                  <span>样本：</span>
                  <span :class="{'type-in':item.typeStr=='呼入'}">{{item.sampleCount}}</span>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="img-mask" style="overflow-y:hidden">
                <img src="../../assets/img/pro1.png"  style="width:100%"/>
              </div>
              <div style="padding:18px 16px 0;color:rgba(51, 51, 51, 1);font-size:16px;">
                更多模板，敬请期待
              </div>
            </div>
          </div>
      </div>
      <router-link v-if="ifLogin" target="_blank" rel="opener" class="dialogBox" to="/Communication">
        <a-icon style="z-index:1000;font-size:25px" type="message" />
      </router-link>
      <a-modal v-model="visible" title="机器人详情" footer='' width='800px'>
        <div class="robbot-detail">
          <div style="color: rgba(51, 51, 51, 1);font-size: 18px;font-weight:bold">{{currentItem.name}}</div>
          <div style="color: rgba(204, 204, 204, 1);font-size: 14px;margin-top:16px;">{{currentItem.scene}}</div>
          <div class="btn-group" style="padding-bottom:24px;border-bottom:1px solid rgba(240, 240, 240, 1);margin-bottom:24px;width:100%">
            <router-link target="_blank"  rel="opener" :to="{path:'/Communication',query:{projectId:currentItem.id,type:'public',projectName:currentItem.name}}">
              <span>文字模拟</span>
            </router-link>
            <span @click="usePhone">电话体验</span>
          </div>
          <div>
            <a-icon style="color:rgba(34, 215, 187, 1)" type="caret-right" />
            <span>录音展示</span>
          </div>
          <div class="detail-list">
            <div class="head">
              <span>通话时长</span>
              <span>标签</span>
              <span>操作</span>
            </div>
            <ul>
              <li v-for="(item, index) in callRecordList" :key="index">
                <span>{{secondToDate(item.duration/1000)}}</span>
                <span>
                  <span style="padding-left:0px;display:inline;margin-right:10px" v-for="(newItem, newIndex) in item.labelList" :key="newIndex">
                    {{newItem}}
                  </span>
                </span>
                <router-link target="_blank" rel="opener" :to="{path:'/SimulatedDialogue',query:{source:'dialogues',roomId:item.roomId,id:item.id}}">
                  <a-icon type="play-circle" />
                  播放
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </a-modal>
      <a-modal v-model="phoneModal" title="电话模拟-请输入手机号" footer='' width='554px'>
        <div class="phone-detail">
          <div style="color: rgba(51, 51, 51, 1);font-size: 18px;font-weight:bold">{{currentItem.name}}</div>
          <div style="margin-top:24px;">
            <span style="color:rgba(80, 80, 80, 1);font-size:14px;width:136px;display:inline-block">请输入您的手机号：</span>
            <a-input style="width:370px;height:40px" v-model="userPhone" placeholder="请输入手机号码">
              <a-icon style="color:rgba(34, 215, 187, 1)" slot="prefix" type="user" />
            </a-input>
          </div>
          <div style="height:35px;">
            <span style="width:136px;display:inline-block;height:35px"></span>
            <span style="font-size:12px;height:35px;display:inline-block;width:370px">
              <span style="color:rgba(34, 215, 187, 1);font-size:20px;float:left;margin-right:4px;line-height:24px">*</span>
              <span style="color:rgba(204, 204, 204, 1);font-size:12px;">温馨提示：您输入的手机号仅用于电话模拟，不用于其他任何地方，我们会保护您的隐私安全，请放心试用</span>
            </span>
          </div>
          <div style="height:35px;margin-top:24px">
          <span style="width:80px;height:32px;line-height:32px;text-align:center;color:#fff;font-size:14px;border-radius:4px;background:rgba(34, 215, 187, 1);display:inline-block;float:right;cursor:pointer" @click='playCall(currentItem.id)'>提交</span>
          </div>
        </div>
      </a-modal>
      <a-modal
        :mask-closable="true"
        title="试听"
        :visible="visibleListen"
        @ok="handleOkListen"
        okText="确认" cancelText="取消"
        @cancel="handleCancelListen"
        >
        <div v-if="voiceUrl!=''" :key='randomNum'>
            <audio controls autoplay :src="voiceUrl"></audio>
        </div>
        <div v-if="voiceUrl==''">暂无录音</div>
      </a-modal>
    </div>
    <div class="content-phone">
      <div class="audio" style="width:100%" :key='randomNum'>
        <audio  style="width:90%;margin:6px auto;display:none" controls :src="voiceDetailUrl" autoplay="autoplay"></audio>
      </div>
      <div class="bg-img">
        <!-- <img src="../../assets/img/pro2.gif" alt=""> -->
        <a-carousel :autoplay='true'>
          <div>
            <img src="../../assets/img/banner4.jpg" alt="">
          </div>
          <div>
            <img src="../../assets/img/banner5.jpg" alt="">
          </div>
          <div>
            <img src="../../assets/img/banner6.jpg" alt="">
          </div>
        </a-carousel>
        <div class="condition">
          <div class="condition-content">
            <div style="width:50%;height:100%;float:left;line-height:52px;text-align:center" @click="showSelect1">
              <span style="margin-right:5px">{{selectHtml1}}</span>
              <a-icon v-if="selectOption1" type="caret-up" />
              <a-icon v-if="!selectOption1" type="caret-down" />
            </div>
            <div style="width:50%;height:100%;float:left;line-height:52px;text-align:center" @click="showSelect2">
              <span style="margin-right:5px">{{selectHtml2}}</span>
              <a-icon v-if="selectOption2" type="caret-up" />
              <a-icon v-if="!selectOption2" type="caret-down" />
            </div>
          </div>
        </div>
        <div v-if="selectOption1" style="position:absolute;top:175px;width:100%;background:#fff;z-index:10;max-height:250px;overflow-y:auto;box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.08)">
          <ul style="margin-bottom:0px;">
            <li :class="{'active':selectHtml1=='全部'}" @click="handleChange(-2,'全部')" style="height:40px;line-height:40px;padding:0 10px;border-bottom:1px solid #f5f5f5;" value="-2">全部</li>
            <li :class="{'active':selectHtml1==item.name}" @click="handleChange(item.id,item.name)" style="height:40px;line-height:40px;padding:0 10px;border-bottom:1px solid #f5f5f5;" v-for="(item, index) in belongsToTpeList" :key="index" :value="item.id">{{item.name}}</li>
            <li :class="{'active':selectHtml1=='其他'}" @click="handleChange(-1,'其他')" style="height:40px;line-height:40px;padding:0 10px;" value="-1">其他</li>
          </ul>
        </div>
        <div v-if="selectOption2" style="position:absolute;top:175px;width:100%;background:#fff;z-index:10;max-height:250px;overflow-y:auto;box-shadow:0px 2px 12px 0px rgba(0, 0, 0, 0.08)">
          <ul style="margin-bottom:0px;">
            <li :class="{'active':selectHtml2=='全部'}" @click="filterCallaType(' ','全部')" style="height:40px;line-height:40px;padding:0 10px;border-bottom:1px solid #f5f5f5;" value="">全部</li>
            <li :class="{'active':selectHtml2=='呼入'}" @click="filterCallaType('IN','呼入')" style="height:40px;line-height:40px;padding:0 10px;border-bottom:1px solid #f5f5f5;" value="IN">呼入</li>
            <li :class="{'active':selectHtml2=='呼出'}" @click="filterCallaType('OUT','呼出')" style="height:40px;line-height:40px;padding:0 10px;" value="OUT">呼出</li>
          </ul>
        </div>
      </div>
      <div class="content-list">
        <div style="height:30px;width:100%;background:#fff"></div>
        <div class="list-info" v-for="(item, index) in proList" :key="index">
          <!-- <img class="avator" src="../../assets/img/avator/admin-15.jpg" alt=""> -->
          <img v-if="item.picture!=''" :src="item.picture" class="avator"/>
          <img v-if="item.picture==''"  src="../../assets/img/pro1.png" class="avator"/>
          <div class="list-info-head">
            
            <div class="title">
              <div class="title-name">
                <span>{{item.name.length>12?item.name.substring(0,11)+'...':item.name}}</span>
                <img @click="changeBoolItem(item.id)" src="../../assets/img/play.svg" alt="" style="width:20px;float:right">
              </div>
              <div class="title-content">
                <span>节点：{{item.nodeCount}}</span>
                <span>意图：{{item.intentionCount}}</span>
                <span>样本：{{item.sampleCount}}</span>
              </div>
              <div class="list-info-content">
                <div class="btn">
                  <router-link rel="opener" :to="{path:'/Communication',query:{projectId:item.id,type:'public',projectName:item.name}}">
                    <div class="btn1">
                      <img src="../../assets/img/msg-phone.svg" alt="">
                      <span>文字模拟</span>
                    </div>
                  </router-link>
                  
                  <div @click="tryCall(item.id)">
                    <img src="../../assets/img/call-phone.svg" alt="">
                    <span>电话体验</span>
                  </div>
                </div>
                <!-- <span>{{secondToDate(item.duration)}}</span>
                <span>
                  <span v-for="(newItem, newIndex) in item.labelList" :key="newIndex">
                    {{newItem}}
                  </span>
                </span>
                <span @click="tryListen(item.voice_url)">
                  <a-icon type="play-circle" />
                  播放
                </span> -->
              </div>
            </div>
          </div>

        </div>
      </div>
      <a-modal v-model="phoneStateModal" title="" footer='' style="position:relative;padding-bottom:210px">
        <div style="padding:0 16px;">
          <div style="font-size:16px;color:rgba(51, 51, 51, 1);text-align:center;font-weight:bold;padding-top:16px">请输入您的手机号码</div>
          <div style="color:rgba(80, 80, 80, 1);font-size:14px;margin:16px 0">请输入您的手机号码，我们的机器人会及时给您回电</div>
          <div>
            <a-input ref="userNumberInput" v-model="userPhone" style="height:40px;">
              <a-icon slot="prefix" type="mobile"/>
            </a-input>
          </div>
          <div style="color:rgba(34, 215, 187, 1);font-size:12px;margin:8px 0 4px">*温馨提示</div>
          <div style="color:rgba(153, 153, 153, 1);font-size:10px;padding-left:5px;margin-bottom:16px;">您输入的手机号仅用于电话模拟，不用于其他任何地方，我们会保护您的隐私安全，请放心试用</div>
        </div>
        
        <div style="border-top:1px solid rgba(238, 238, 238, 1);font-size:15px;height:45px;line-height:45px;text-align:center;">
          <div style="width:50%;float:left;border-right:1px solid rgba(238, 238, 238, 1);color:rgba(56, 56, 56, 1)" @click="offShowModal">取消</div>
          <div style="width:50%;float:left;color:rgba(34, 215, 187, 1)" @click='playCall(currentPhoneId)'>提交</div>
        </div>
      </a-modal>
      <a-modal v-model="phoneVoiceList" title="" footer='' style="position:relative">
        <div style="padding:0 16px;height:400px;overflow-y:auto">
          <div style="border-bottom:1px solid rgba(236, 236, 236, 1);padding:16px 0;margin-bottom:16px">
            <div style="color:rgba(51, 51, 51, 1);font-size:16px;">项目简介</div>
            <div style="color:rgba(204, 204, 204, 1);font-size:13px;">{{callRecordListPhone.description}}</div>
          </div>
          <div style="color:rgba(51, 51, 51, 1);font-size:16px;margin-bottom:8px;">语音记录</div>
          <div class="voice" v-for="(item, index) in callRecordListPhone.callRecordList" :key="index" style="display:flex;margin-bottom:16px;">
            <div style="flex:1">
                <div style="color:rgba(80, 80, 80, 1);font-size:13px">录音案例：{{secondToDate(item.duration/1000)}}</div>
                <div style="color:rgba(204, 204, 204, 1);font-size:12px;margin-top:8px;overflow:hidden">
                  <span v-for="(newItem, newIndex) in item.labelList" :key="newIndex">
                    {{newItem}}
                  </span>
                </div>
            </div>
            <div class="play-phone" style="display:inline-block;width:48px;">
              <router-link :to="{path:'/SimulatedDialogue',query:{source:'dialogues',roomId:item.roomId,id:item.id}}">
              <a-icon type="menu-unfold" style="color:rgba(34, 215, 187, 1)" />
              <span style="color:rgba(34, 215, 187, 1);margin-left:4px;">播放</span>
              </router-link>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
export default {
  // metaInfo: {
  //   meta: [
  //     { charset: 'utf-8' },
  //     { name: 'viewport', content: 'width=device-width' }
  //   ]
  // },
  name: 'DialectSquare',
  props: {
    msg: String
  },
  data() {
    return {
      selectedTagId: '',
      belongsToTpeList: [],
      proList: [],
      typeValue: '',
      value: '',
      visible: false,
      currentItem: '',
      phoneModal: false,
      userPhone: "",
      ifLogin: false,
      callRecordList: [],
      voiceUrl: '',
      visibleListen: false,
      phoneStateModal: false,
      currentPhoneId: '',
      selectOption1: false,
      selectOption2 : false,
      selectHtml1: '选择行业',
      selectHtml2: '呼叫类型',
      voiceDetailUrl: '',
      randomNum: 1,
      phoneVoiceList: false,
      callRecordListPhone: ''
    };
  },
  methods: {
    startPlay(url) {
      this.randomNum ++
      this.voiceDetailUrl = url
    },
    changeBoolItem(id) {
      this.phoneVoiceList = true
      this.queryProDetail(id)
    },
    playCall(id) {
      this.phoneModal = false
      this.phoneStateModal = false
      this.axios.post('/api/public/project/phone', {
        phone: this.userPhone,
        projectId: id
      })
      .then(response=> {
          if(response.data.code == 0){
            this.userPhone = ''
               this.$message.success('已呼出');
          }else{
              this.$message.error(response.data.message);
          }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    tryListen(url) {
      this.randomNum ++
      this.visibleListen = true
      this.voiceUrl = url
    },
    handleOkListen() {
      this.visibleListen = false
    },
    handleCancelListen() {
      this.visibleListen = false
    },
    secondToDate(result) {
      let h = Math.floor(result / 3600);
      let m = Math.floor((result / 60 % 60));
      let s = Math.floor((result % 60));
      return result = (h!=0?h+"小时":"") + (m!=0?m+"分":"") + s + "秒";
    },
    handleChange(id,text) {
      if(text!=undefined){
        this.selectHtml1 = text
        this.selectOption1 = false
      }
      if(id == -2){
        this.selectedTagId = ''
      }else if(id == -1){
        this.selectedTagId = -1
      }else{
        this.selectedTagId = id
      }
      this.queryData()
    },
    handleSelectChange(e) {
      this.typeValue = e.target.value
      this.queryData()
    },
    filterCallaType(e,text) {
      this.typeValue = e
      this.selectHtml2 = text
      this.selectOption2 = false
      this.queryData()
    },
    queryData() {
      this.proList = []
      this.axios(
        {
          url:'/api/public/project/list', 
          params:{
            sceneId: this.selectedTagId,
            type: this.typeValue,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.proList = response.data.data
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    queryProDetail(id) {
      this.axios( 
        {
            method:'get',
            url:'/api/public/project', 
            params: {
                id: id
            }
        }
      )
      .then(response=> {
          if(response.data.code == 0){
            this.callRecordList = response.data.data.callRecordList
            this.callRecordListPhone = response.data.data
          }else{
             this.$message.error(response.data.message);
          }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    selectItem(item) {
      this.visible = true;
      this.currentItem = item
      this.queryProDetail(item.id)
    },
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
    usePhone() {
      this.visible = false;
      this.phoneModal = true
    },
    tryCall(id) {
      this.phoneStateModal = true
      this.currentPhoneId = id
    },
    offShowModal() {
      this.phoneStateModal = false
    },
    showSelect1() {
      this.selectOption2 = false
      this.selectOption1 = !this.selectOption1
    },
    showSelect2() {
      this.selectOption1 = false
      this.selectOption2 = !this.selectOption2
    }
  },
  mounted: function() {
    this.sessionData('set','currentNavItem','DialectSquare');
    if(this.sessionData('get','token')){
      this.ifLogin = true
    }
    this.queryData()
    this.axios.get('/api/dropdown/scene')
    .then(response=> {
      if(response.data.code == 0){
        this.belongsToTpeList = response.data.data
      }else{
        this.$message.error(response.data.message);
      }
    })
    .catch(error=> {
      console.log(error)
    })
  }
}
</script>
<style scoped lang="less">
  .dialect-square{
    height: 100%;
    background: rgba(240, 242, 243, 1);
    overflow-y: auto;
    padding-bottom: 74px;
    .bg{
      height: 200px;
      // background: url(../../assets/img/bg.jpg);
      // display: flex;
      img{
        // width: 100%;
      }
    }
    .contain{
      width: 1440px;
      // padding: 24px;
      margin: 0 auto;
      margin-top:24px;
      .tag-list{
        flex: 1;
        span{
          display:inline-block;
          margin-right:16px;
          color: rgba(80, 80, 80, 1);
          font-size: 14px;
          cursor: pointer;
        }
        span.active{
          color: rgba(34, 215, 187, 1);
        }
      }
      .card-list{
        width: 1440px;
        div.card{
          display: inline-block;
          margin-top: 16px;
          background: #fff;
          width: 274px;
          height: 274px;
          float: left;
          box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);
          // border-radius: 4px;
          padding: 4px;
          cursor: pointer;
          .img-mask{
            height:183px;
            width:100%;
            position: relative;
            .mask{
              position: absolute;
              width: 100%;
              height: 183px;
              left: 0px;
              top: 0px;
              color: #fff;
              background-color: rgba(0, 0, 0, 0.7);
              font-size: 14px;
              z-index: 10;
              padding: 20px 12px 0;
              display: none;
            }
          }

          .img-mask:hover{
             .mask{
               display: block;
             }
          }
          .node-count{
            span{
              color:rgba(153, 153, 153, 1);
              font-size:12px;
            }
          }
        }
        div.distance-right{
          margin-right: 17px;
        }
      }
    }
    .content-phone{
      display: none;
    }
  }
  .robbot-detail{
    .btn-group{
      margin: 24px auto 0;
      width: 345px;
      display: block;
      cursor: pointer;
      span{
        display:inline-block;
        width: 160px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        color: #fff;
        font-size: 14px;
        border-radius: 4px;
      }
      span:nth-child(1){
        background: rgba(34, 215, 187, 1);
        margin-right: 24px;
      }
      span:nth-child(2){
        background: rgba(78, 138, 250, 1);
      }
    }
    .detail-list{
      margin-top: 16px;
      .head{
        height:30px;
        line-height:30px;
        background:#F0F0F0;
        color: rgba(51, 51, 51, 1);
        span{
          display:inline-block;
          padding-left: 24px;
        }
        span:nth-child(1){
          width: 20%;
          float: left;
        }
        span:nth-child(2){
          width: 60%;
          float: left;
        }
        span:nth-child(3){
          width: 20%;
          float: left;
        }
      }
      ul{
        li{
          height: 30px;
          line-height: 30px;
          span{
            display:inline-block;
            padding-left: 24px;
          }
          span:nth-child(1){
            width: 20%;
            // float: left;
            color: rgba(51, 51, 51, 1);
          }
          span:nth-child(2){
            width: 60%;
            // float: left;
            color: rgba(204, 204, 204, 1);
          }
          span:nth-child(3){
            width: 20%;
            // float: left;
            color: #22d7bb;
            cursor: pointer;
          }
          a{
            color: #22d7bb;
            padding-left: 24px;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 770px) {
    .dialect-square{
      height: 100%;
      background: rgba(240, 242, 243, 1);
      overflow-y: auto;
      padding-bottom: 10px;
      .content-pc{
        display: none;
      }
      .content-phone{
        display: block;
        .bg-img{
          position: relative;
          li.active{
            background: rgba(34, 215, 187, 0.1);
            color:#22d7bb;
          }
          img{
            width: 100%;
          }
          .condition{
            padding:0 16px;
            position: absolute;
            bottom: -26px;
            width: 100%;
            height: 52px;
            margin: 0 auto;
            div.condition-content{
              background: #fff;
              width: 100%;
              height:52px;
              box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.08);
              border-radius: 4px;  
            }
          }
        }
        .content-list{
          // padding-top:30px;
          .list-info{
            padding: 8px;
            background: #fff;
            margin-bottom:6px;
            height:104px;
            display: flex;
            img.avator{
              width: 110px;
              margin-right: 10px;
            }
            .list-info-head{
              flex: 1;
              .title{
                flex: 1;
                .title-name{
                  span{
                    color: rgba(51, 51, 51, 1);
                    font-size: 16px;
                  }
                }
                .title-content{
                  color: rgba(153, 153, 153, 1);
                  font-size: 13px;
                  margin-top: 8px;
                  span{
                    margin-right: 16px;
                    display: inline-block;
                  }
                }
                .list-info-content{
                  margin-top:10px;
                  .btn{
                    div{
                      display: inline-block;
                      text-align: center;
                      color: rgba(78, 138, 250, 1);;
                      img{
                        width: 14px;
                      }
                    }
                    div.btn1{
                      width: 50%;
                      text-align: left;
                      color: rgba(34, 215, 187, 1);
                    }
                  }
                  .voice{
                    display: flex;
                    margin-top: 12px;
                    margin-right: 15%;
                  }
                }
              }
            }
           
          }
        }
      }
    }
  }
</style>
